module.exports = __webpack_public_path__ + "img/17.5ede4d18.jpg";